<div>
	<h1>
		<span><ng-content></ng-content></span>
		<hr />
	</h1>
	<h2>
		<ng-content select="[subtitle]"></ng-content>
	</h2>
</div>
